<template>
  <div class="directory-display">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="page-header">
            <button
              @click="newAuthorityContact()"
              class="btn btn-primary btn-lg float-right my-1 mx-1">
              <i class="fa fa-plus fa-fw mr-2"></i> Add New Contact
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    // DELETE_DATABASE_OBJECT,
    // EDIT_DATABASE_OBJECT,
    NEW_DATABASE_OBJECT
  } from '@/vuex/types'
  export default {
    name: 'DirectoryDisplay',
    computed: {
    },
    data () {
      return {}
    },
    mounted () {
    },
    methods: {
      async newAuthorityContact () {
        await this.$store.dispatch(NEW_DATABASE_OBJECT, 'newAuthorityContact')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/DirectoryDisplay.vue